import { css } from '@emotion/core'
import { mediumUp } from 'Utils'

export default ({ theme: { colors } }) => css`
  .visible-part {
    &:hover {
      cursor: pointer;
    }
  }

  .item {
    width: 100%;
    box-sizing: border-box;

    .header {
      position: relative;
      display: flex;
      align-items: center;
      height: 3rem;

      > * {
        display: flex;
        align-items: center;
      }

      .header-details {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
    }

    .hidden-part {
      overflow: hidden;

      .hidden-details {
        margin-bottom: 2rem;
        margin-top: -200%;
        transition: margin-top 0.3s ease-in-out 0s;
      }
    }

    .filter-arrow {
      margin-left: 2rem;
      width: 30px;
      transform: rotate(-90deg);
      transition: transform 0.3s;
      transform-origin: center center;
    }

    &.open {
      .filter-arrow {
        transform: rotate(0deg);
      }

      .item-button {
        &:before,
        &:after {
          height: 14px;
        }
        &:before {
          transform: translate(0%, -50%) rotate(-45deg);
        }
        &:after {
          transform: translate(0%, -50%) rotate(45deg);
        }
      }

      .hidden-details {
        margin-top: 0px;
        transition: margin-top 0.3s ease-in-out 0s;
      }

      .plus-minus {
        &::before {
          transform: rotate(180deg);
        }
        &::after {
          transform: rotate(180deg);
        }
      }
    }
  }

  .plus-minus {
    box-sizing: border-box;
    transition: transform 0.3s;
    width: 14px;
    height: 14px;
    transform: rotate(180deg);
    position: absolute;
    right: 1rem;
    top: 1.25rem;
    display: inline-block;

    &:hover {
      cursor: pointer;
    }

    &::before {
      content: '';
      display: block;
      width: 14px;
      height: 0px;
      border-bottom: solid 2px ${colors.body};
      position: absolute;
      bottom: calc(14px / 2 - 2px / 2);
      transform: rotate(90deg);

      transition: transform 0.3s linear;
      transform-origin: center center;
    }

    &::after {
      content: '';
      display: block;
      width: 14px;
      height: 0px;
      border-bottom: solid 2px ${colors.body};
      position: absolute;
      bottom: calc(14px / 2 - 2px / 2);
      transition: transform 0.3s linear;
      transform: rotate(0);
    }
  }

  @media ${mediumUp} {
  }
`
